import React, { Component } from "react";
import classes from "./Tab.module.css";

import PropTypes from "prop-types";

class Tab extends Component {
  static propTypes = {
    activeTab: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
  };

  onClick = () => {
    const { label, onClick } = this.props;
    onClick(label);
  };

  render() {
    const {
      onClick,
      props: { activeTab, label }
    } = this;

    let className = [classes.TabListItem];

    if (activeTab === label) {
      className = [classes.TabListItem, classes.TabListActive];
    }

    return (
      <li className={className.join(" ")} onClick={onClick}>
        {label}
      </li>
    );
  }
}

export default Tab;
